import { GetAllPagesResponse } from '@fullstory/proto/fs/services/dx-objects';
import { AutocompleteReply, GetAllReply, MLState } from '@fullstory/proto/fs/services/paige';
import { page1, page2 } from './state';

export const PAGE_DEFINITIONS_RESPONSE: GetAllPagesResponse = {
  pages: [],
  learnedLimit: 1000,
  maxPages: 7500,
  mlState: MLState.UNSET,
  pendingSuggestedPages: [],
};
export const AUTOCOMPLETE_RESPONSE: AutocompleteReply = { suggestions: [] };
export const PAGE_DEFINITIONS_PAIGE_RESPONSE: GetAllReply = {
  pages: [page1, page2],
  learnedLimit: 1000,
  maxPages: 7500,
  mlState: MLState.UNSET,
  pendingSuggestedPages: [],
};
export const PAGE_DEFINITIONS_DXO_RESPONSE: GetAllPagesResponse = {
  pages: [{ page: page1 }, { page: page2 }],
  learnedLimit: 1000,
  maxPages: 7500,
  mlState: MLState.UNSET,
  pendingSuggestedPages: [],
};

export const PAGE_DEFINITIONS_HEATMAPS_RESPONSE = PAGE_DEFINITIONS_PAIGE_RESPONSE;
